module.exports = __webpack_public_path__ + "static/halfling_rogue_female_SCAG-8f31ad0ca4914fe6a373d8ea968aa2d4.png";